import Modal from 'Components/Modal'
import {ThumbsFooter} from 'Components/Modal/ThumbsFooter'
import {IncomingRequestType, ApproveRejectModalRequestType} from 'Interfaces'
import {FC} from 'react'
import styles from './ModalRejectPlacementConfirmation.module.scss'
import {CandidateDashboardTranslations as cdt} from 'Services/I18n/Constants'
import {FormattedMessage} from 'react-intl'
import {ForumOutlined} from '@mui/icons-material'

interface ModalRejectPlacementConfirmation {
  request: IncomingRequestType
  rejectModal: boolean
  setRejectModal: (rejecModal: boolean) => void
  setIsOpenPlacementModal?: (value: boolean) => void
  rejectPlacementConfirmation: (payload: ApproveRejectModalRequestType) => void
}

export const ModalRejectPlacementConfirmation: FC<
  ModalRejectPlacementConfirmation
> = ({
  request,
  rejectModal,
  setRejectModal,
  rejectPlacementConfirmation,
  setIsOpenPlacementModal,
}) => {
  return (
    <>
      <Modal
        className={styles.modal}
        icon={ForumOutlined}
        isOpen={rejectModal}
        title={cdt.rejectPlacement}
        theme={'error'}
        onAfterClose={() => {
          setRejectModal(false)
        }}
        Footer={
          <ThumbsFooter
            rejectText={cdt.reject}
            theme={'thumbDown'}
            onReject={() => {
              rejectPlacementConfirmation({
                id: request.id,
              })
              setRejectModal(false)
              setIsOpenPlacementModal && setIsOpenPlacementModal(false)
            }}
            onCancel={() => {
              setRejectModal(false)
            }}
          />
        }
      >
        <div className={styles.containerInterview}>
          <p className={styles.text}>
            <FormattedMessage id={cdt.placementRejectAreYouSure} />{' '}
            {request.companyName}?
          </p>
          <p className={styles.description}>
            <FormattedMessage id={cdt.placementRejectYouWillMiss} />
          </p>
        </div>
      </Modal>
    </>
  )
}
